// Custom Head Code Manager
// Admin se paste kiya hua code <head> mein inject karta hai

const STORAGE_KEY = 'custom_head_code';
const INJECTED_ATTR = 'data-custom-head-injected';

export function getCustomHeadCode(): string {
  if (typeof window === 'undefined') return '';
  return localStorage.getItem(STORAGE_KEY) || '';
}

export function saveCustomHeadCode(code: string): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(STORAGE_KEY, code);
}

export function clearCustomHeadCode(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(STORAGE_KEY);
}

// Remove previously injected custom head elements
function removeInjectedElements(): void {
  const existing = document.querySelectorAll(`[${INJECTED_ATTR}]`);
  existing.forEach(el => el.remove());
}

// Inject custom head code into <head>
export function injectCustomHeadCode(): void {
  if (typeof window === 'undefined') return;

  const code = getCustomHeadCode();

  // Remove old injected elements first
  removeInjectedElements();

  if (!code.trim()) return;

  try {
    // Parse the HTML string to extract individual elements
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<html><head>${code}</head><body></body></html>`, 'text/html');
    const headChildren = Array.from(doc.head.children);

    headChildren.forEach(el => {
      if (el.tagName === 'SCRIPT') {
        // Scripts need to be re-created to execute
        const script = document.createElement('script');
        script.setAttribute(INJECTED_ATTR, 'true');

        // Copy all attributes
        Array.from(el.attributes).forEach(attr => {
          script.setAttribute(attr.name, attr.value);
        });

        // Copy inline content
        if (el.textContent) {
          script.textContent = el.textContent;
        }

        document.head.appendChild(script);
      } else {
        // For meta, link, style, noscript etc.
        const clone = el.cloneNode(true) as Element;
        clone.setAttribute(INJECTED_ATTR, 'true');
        document.head.appendChild(clone);
      }
    });

    console.log('[CustomHead] Injected', headChildren.length, 'element(s) into <head>');
  } catch (err) {
    console.error('[CustomHead] Injection failed:', err);
  }
}

// Re-inject after settings change
export function reinjectCustomHeadCode(): void {
  removeInjectedElements();
  setTimeout(() => {
    injectCustomHeadCode();
  }, 100);
}
